/**
 *
 */
import { get, post, put } from 'mdoc/admin/axios/tools'
import * as config from 'mdoc/admin/axios/config'

//クライアント
export const getClient = (param) => new Promise((resolve, reject) => {
    get(config.CLIENTS, param)
        .then(function (response) {
            resolve({ results: response.docTblClientList, count: response.count })
        }).catch(function (error) {
            reject(error);
        })
})
//クライアント详细接口
export const getClientDetail = (id, param) => new Promise((resolve, reject) => {
    get(config.CLIENTS_DETAIL + id, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({ results: response })
            }
        }).catch(function (error) {
            reject(error);
        })
})
//クライアントCode checkAPI
export const clientCodeCheck = (param) => new Promise((resolve, reject) => {
    get(config.CLIENTS_CODE_CHECK, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({ results: response })
            }
        }).catch(function (error) {
            reject(error);
        })
})

//クライアント情報を登録する
export const addClient = (param) => new Promise((resolve, reject) => {
    post(config.CLIENTS_ADD, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({ results: response })
            }
        }).catch(function (error) {
            reject(error);
        })
})

//クライアント変更
export const updateClient = (param) => new Promise((resolve, reject) => {
    put(config.CLIENTS_PUT, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({ results: response })
            }
        }).catch(function (error) {
            reject(error);
        })
})

//ステータスを変更する
export const updateStatusClient = (param) => new Promise((resolve, reject) => {
    get(config.CLIENTS_STATUS, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({ results: response })
            }
        }).catch(function (error) {
            reject(error);
        })
})